import React, { useMemo } from 'react';

import Location from '@r6digital/rapidstor-types/react/entities/Location';

import { CorporationCode, getCorpTranslations } from '@/features/translations/helpers';

import classes from './styles.module.scss';

import LocationMarker from '../../../assets/icon-location-marker.svg?react';
import BackLink from './backlink';

interface Props {
    location: Location | undefined;
}

function Navbar(props: Props) {

    const locationName = useMemo(() => {
        if (!props.location) {
            return '';
        }

        const translations = getCorpTranslations(props.location.corpCode as CorporationCode);

        if (!translations || !window.rapidstor_settings.app_config.journey.unitTypeRegex) {
            return props.location.name;
        }

        // if translations.locations exists
        if ('locations' in translations) {
            const locationPrefixes = translations.locations as Record<string, string>;

            return locationPrefixes[window.rapidstor_settings.app_config.journey.unitTypeRegex];
        }

        return props.location.name;
    }, [props.location]);

    return (
        <div className={classes.nav} data-testid='navbar'>
            <div className={classes.navbarContainer}>
                <div
                    style={{
                        flexDirection: 'row',
                        display: 'flex',
                        padding: '4px 0',
                    }}
                >
                    <BackLink />
                    <div className={classes.header_content}>
                        <div>
                            <LocationMarker className={classes.marker} />
                            <span className={classes.location}>
                                {locationName}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Navbar;
